import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

interface IFormKey {
  formId: number
  code: string
}

export interface ISustainabilityFormsFY24 {
  [CrudStoreItem.SustainabilityAttachments24]: IFormKey
  [CrudStoreItem.SustainabilityAttachments24Table]: IFormKey
  [CrudStoreItem.ExecutiveSponsorshipFormM0124]: IFormKey
  [CrudStoreItem.SustainableProcurementM0224]: IFormKey
  [CrudStoreItem.CommunicationsReportingFormM0524]: IFormKey
  [CrudStoreItem.PrintFleetAssessmentM0924]: IFormKey
  [CrudStoreItem.MarketingCampaignFormM11124]: IFormKey
  [CrudStoreItem.CustomerAwarenessFormM1124]: IFormKey
  [CrudStoreItem.SyndicatedContentFormM11224]: IFormKey
  [CrudStoreItem.OfficeRecyclingFormM1424]: IFormKey
  [CrudStoreItem.EnergyEfficiencyFormM1624]: IFormKey
  [CrudStoreItem.DEIStrategyFormM1824]: IFormKey
  [CrudStoreItem.EmployeeWellBeingFormM2124]: IFormKey
  [CrudStoreItem.VolunteeringFormM2224]: IFormKey
  [CrudStoreItem.CommunityEngagementFormM2424]: IFormKey
  [CrudStoreItem.CarbonFootprintActionM1524]: IFormKey
  [CrudStoreItem.CustomerCaseStudiesM1024]: IFormKey
  [CrudStoreItem.SustainabilityFormM1324]: IFormKey
  [CrudStoreItem.UserInitiativesForm24]: IFormKey
  [CrudStoreItem.SustainabilityDealFormM0724]: IFormKey
  [CrudStoreItem.SustainabilityPlanItems24]: IFormKey
  [CrudStoreItem.VisionFormM25]: IFormKey
  [CrudStoreItem.EWasteFormM30]: IFormKey
  [CrudStoreItem.OnlineBrandingFormM31]: IFormKey
  [CrudStoreItem.OnlineBrandingFormM38]: IFormKey
}

export const FY24FormKeys: ISustainabilityFormsFY24 = {
  [CrudStoreItem.SustainabilityAttachments24]: {
    formId: 1486,
    code: 'ai-hp-amplify-attachments-hp-report',
  },
  [CrudStoreItem.SustainabilityAttachments24Table]: {
    formId: 1486,
    code: 'ai-hp-amplify-attachments-hp-report',
  },
  [CrudStoreItem.ExecutiveSponsorshipFormM0124]: {
    formId: 1474,
    code: 'ai-executive-sponsorship-form-m-01-hp-report',
  },
  [CrudStoreItem.SustainableProcurementM0224]: {
    formId: 1491,
    code: 'ai-it-procurement-form-m-02-hp-report',
  },
  [CrudStoreItem.SustainabilityDealFormM0724]: {
    formId: 1472,
    code: 'ai-sustainability-deal-form-m-07-hp-report',
  },
  [CrudStoreItem.PrintFleetAssessmentM0924]: {
    formId: 1494,
    code: 'ai-print-fleet-assessments-m-09-hp-report',
  },
  [CrudStoreItem.CommunicationsReportingFormM0524]: {
    formId: 1475,
    code: 'ai-comm-reporting-form-m-05-hp-report',
  },
  [CrudStoreItem.MarketingCampaignFormM11124]: {
    formId: 1492,
    code: 'ih-marketing-campaign-m11-1-hp-report',
  },
  [CrudStoreItem.CustomerAwarenessFormM1124]: {
    formId: 1492,
    code: 'ih-marketing-campaign-m11-1-hp-report',
  },
  [CrudStoreItem.SyndicatedContentFormM11224]: {
    formId: 1493,
    code: 'ai-syndication-showcase-report-m-11-2',
  },
  [CrudStoreItem.OfficeRecyclingFormM1424]: {
    formId: 1477,
    code: 'ai-office-recycling-form-m-14-hp-report',
  },
  [CrudStoreItem.EnergyEfficiencyFormM1624]: {
    formId: 1478,
    code: 'ai-energy-efficiency-form-m-16-hp-report',
  },
  [CrudStoreItem.EmployeeWellBeingFormM2124]: {
    formId: 1480,
    code: 'ai-employee-well-being-form-m-21-hp-report',
  },
  [CrudStoreItem.VolunteeringFormM2224]: {
    formId: 1481,
    code: 'ai-volunteering-form-m-22-hp-report',
  },
  [CrudStoreItem.CommunityEngagementFormM2424]: {
    formId: 1482,
    code: 'ai-community-engagement-form-m-24-hp-report',
  },
  [CrudStoreItem.UserInitiativesForm24]: {
    formId: 1487,
    code: 'ai-user-initiatives-form-hp-report',
  },
  [CrudStoreItem.DEIStrategyFormM1824]: {
    formId: 1479,
    code: 'ai-dei-strategy-form-m18-hp-report',
  },
  [CrudStoreItem.SustainabilityPlanItems24]: {
    formId: 1437,
    code: 'sustainability-initiatives-fy24',
  },
  [CrudStoreItem.CustomerCaseStudiesM1024]: {
    formId: 1484,
    code: 'ai-customer-case-studies-form-m-10-hp-report',
  },
  [CrudStoreItem.SustainabilityFormM1324]: {
    formId: 1485,
    code: 'ai-planet-partners-supplies-recycling-m-13-hp',
  },
  [CrudStoreItem.CarbonFootprintActionM1524]: {
    formId: 1483,
    code: 'ai-carbon-footprint-action-plan-m-15-report',
  },
  [CrudStoreItem.VisionFormM25]: {
    formId: 1532,
    code: 'ai-vision-m-25-report',
  },
  [CrudStoreItem.EWasteFormM30]: {
    formId: 1851,
    code: 'ai-e-waste-m-30-report',
  },
  [CrudStoreItem.OnlineBrandingFormM31]: {
    formId: 1853,
    code: 'ai-online-branding-m-31-report',
  },
  [CrudStoreItem.OnlineBrandingFormM38]: {
    formId: 2078,
    code: 'ai-accreditation-form-m-38',
  },
}
